module.exports = __webpack_public_path__ + "img/icon-unavailable.a4ffca17.svg";